import global from "./global";

export function namespace(name: string): any {
    return name ? name.split('.').reduce((parent: any, next: string) => parent[next] || (parent[next] = {}), global) : global;
}